import React, { Component } from "react";
import { Menu, Pagination, Icon, Label } from "semantic-ui-react";
import BuscaProvincias from "./navMenu/BuscaProvincias";
import CustomSearch from "../../shared/CustomSearch";

class NavMenu extends Component {
  state = {
    value: "",
    localidad_prov: ""
  };

  onPageChange = (e, { activePage }) => this.props.handleChangePage(activePage);

  handleChangeProvincia = opcion => this.props.handleProvinciaActiva(opcion);

  handleSelection = idColegio => {
    this.setState({ value: idColegio });
    this.props.handleColegioBuscado({ idColegio });
  };

  handleSelectionLocalidad = key => {
    this.setState({ localidad_prov: key });
    this.props.handleLocalidad(key);
  };

  handleReset = () => this.handleSelection(null);

  render() {
    return (
      <Menu>
        {this.props.paginasTotales > 1 && (
          <Menu.Item>
            <Pagination
              defaultActivePage={this.props.activePage}
              siblingRange={1}
              firstItem={{
                content: <Icon name="angle double left" />,
                icon: true
              }}
              lastItem={{
                content: <Icon name="angle double right" />,
                icon: true
              }}
              prevItem={{ content: <Icon name="angle left" />, icon: true }}
              nextItem={{ content: <Icon name="angle right" />, icon: true }}
              totalPages={this.props.paginasTotales}
              onPageChange={this.onPageChange}
            />
          </Menu.Item>
        )}
        <Menu.Item>
          <Label basic>
            Buscar por colegio
            <CustomSearch
              id="buscadorColegios"
              name="buscadorColegios"
              type="text"
              datosBusqueda={this.props.nombreColegios}
              onSelect={this.handleSelection}
              handleReset={this.handleReset}
              icon="search"
              value={this.state.value}
            />
          </Label>
        </Menu.Item>
        <BuscaProvincias handleChange={this.handleChangeProvincia} />
        <Menu.Item>
          <Label basic>
            Buscar por localidad
            <CustomSearch
              id="buscadorLocalidad"
              name="buscadorLocalidad"
              type="text"
              datosBusqueda={this.props.localidades}
              onSelect={this.handleSelectionLocalidad}
              handleReset={this.handleReset}
              icon="search"
              value={this.state.localidad_prov}
            />
          </Label>
        </Menu.Item>
      </Menu>
    );
  }
}

export default NavMenu;



// WEBPACK FOOTER //
// ./src/pages/ventas/ventas/NavMenu.jsx